
import FormDialog from "../../helpers/FormDialog";
import moment from "moment";

export const EducationEdit = ({
  onSuccess,
  setOpen,
  open,
  resourceId,
  setValue0,
  value,
}) => {
  return (
    <FormDialog
      maxWidth={"md"}
      open={open > 0}
      onSuccess={onSuccess}
      setOpen={setOpen}
      url={open === 1 ? "/api/resource/education-history/create" : `/api/resource/education-history/update/${resourceId}`}
      title={open === 1 ? "Create Education" : "Edit Education Record"}
      fields={[
        {
          name: "educationRecords",
          label: "Education Institutions (Start with the most recent)",
          type: "array",
          value: value["educationRecords"],
          setValue: (val) => setValue0("educationRecords", val),
          itemLabel: (index, values) => {
            const record = values[index];
            return `Education #${index + 1}`;
          },
          fields: [
            {
              name: "institution",
              label: "Education Institution",
              type: "text",
              required: true,
              value: (index) => value["educationRecords"]?.[index]?.institution || "",
              setValue: (val, index) => {
                const educationRecords = Array.isArray(value["educationRecords"]) ? value["educationRecords"] : [];
                const updatedRecords = [...educationRecords];
                updatedRecords[index] = { ...updatedRecords[index], institution: val };
                setValue0("educationRecords", updatedRecords);
              },
            },
            {
              name: "location",
              label: "Location",
              type: "text",
              required: true,
              value: (index) => value["educationRecords"]?.[index]?.location || "",
              setValue: (val, index) => {
                const educationRecords = Array.isArray(value["educationRecords"]) ? value["educationRecords"] : [];
                const updatedRecords = [...educationRecords];
                updatedRecords[index] = { ...updatedRecords[index], location: val };
                setValue0("educationRecords", updatedRecords);
              },
            },
            {
              name: "fieldOfStudy",
              label: "Major Field of Study",
              type: "text",
              required: true,
              value: (index) => value["educationRecords"]?.[index]?.fieldOfStudy || "",
              setValue: (val, index) => {
                const educationRecords = Array.isArray(value["educationRecords"]) ? value["educationRecords"] : [];
                const updatedRecords = [...educationRecords];
                updatedRecords[index] = { ...updatedRecords[index], fieldOfStudy: val };
                setValue0("educationRecords", updatedRecords);
              },
            },
            {
              name: "degreeDiploma",
              label: "Degree/Diploma",
              type: "text",
              required: true,
              value: (index) => value["educationRecords"]?.[index]?.degreeDiploma || "",
              setValue: (val, index) => {
                const educationRecords = Array.isArray(value["educationRecords"]) ? value["educationRecords"] : [];
                const updatedRecords = [...educationRecords];
                updatedRecords[index] = { ...updatedRecords[index], degreeDiploma: val };
                setValue0("educationRecords", updatedRecords);
              },
            },
            {
              name: "classOfDegree",
              label: "Class of Degree",
              type: "text",
              required: true,
              value: (index) => value["educationRecords"]?.[index]?.classOfDegree || "",
              setValue: (val, index) => {
                const educationRecords = Array.isArray(value["educationRecords"]) ? value["educationRecords"] : [];
                const updatedRecords = [...educationRecords];
                updatedRecords[index] = { ...updatedRecords[index], classOfDegree: val };
                setValue0("educationRecords", updatedRecords);
              },
            },

            {
              name: "startYear",
              label: "Started At",
              type: "date",
              required: true,
              value: (index) => value["educationRecords"]?.[index]?.startYear || "",
              setValue: (val, index) => {
                const educationRecords = Array.isArray(value["educationRecords"]) ? value["educationRecords"] : [];
                const updatedRecords = [...educationRecords];
                updatedRecords[index] = { ...updatedRecords[index], startYear: val };
                setValue0("educationRecords", updatedRecords);
              },
              validate: (v) => {
                if (!v) return "Start date is required";
                const today = moment().startOf("day");
                if (moment(v).isAfter(today)) {
                  return "Start date must be in the past";
                }
                return true;
              },
            },
            {
              name: "endYear",
              label: "Ended At",
              type: "date",
              required: true,
              value: (index) => value["educationRecords"]?.[index]?.endYear || "",
              setValue: (val, index) => {
                const educationRecords = Array.isArray(value["educationRecords"]) ? value["educationRecords"] : [];
                const updatedRecords = [...educationRecords];
                updatedRecords[index] = { ...updatedRecords[index], endYear: val };
                setValue0("educationRecords", updatedRecords);
              },
              minDate: (index) => value["educationRecords"]?.[index]?.startYear || "",
              validate: (v, index) => {
                const startDate = value["educationRecords"]?.[index]?.startYear;
                if (!v && startDate) return "End date is required if start date is provided";
                if (!v) return "End date is required";
                if (startDate && moment(v).isBefore(moment(startDate))) {
                  return "End date cannot be before start date";
                }
                const today = moment().startOf("day");
                if (moment(v).isAfter(today)) {
                  return "End date must be in the past";
                }
                return true;
              },
            },
          ],
        },
      ]}
    />
  );
};